import { Button, Image, Spin } from "antd";
import React from "react";
import { useFetchDocument } from "./useFetchDocument";

const LOADING_STYLE: React.CSSProperties = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  minHeight: "400px",
};

const CONTAINER_STYLE: React.CSSProperties = {
  display: "flex",
  flexDirection: "column",
  height: "100%",
};

const VIEWER_CONTAINER_STYLE: React.CSSProperties = {
  flex: 1,
  overflow: "auto",
  display: "flex",
  justifyContent: "center",
};

const IMAGE_CONTAINER_STYLE: React.CSSProperties = {
  ...VIEWER_CONTAINER_STYLE,
  alignItems: "center",
  padding: "20px",
};

const BUTTON_CONTAINER_STYLE: React.CSSProperties = {
  display: "flex",
  justifyContent: "flex-end",
  gap: "8px",
  padding: "16px",
  borderTop: "1px solid #f0f0f0",
};

const IMAGE_FORMATS = ["jpg", "jpeg", "png", "gif", "webp", "bmp"];

type DocumentViewerProps = {
  documentId?: string | null;
  onClose?: () => void;
};

export const DocumentViewer = (props: DocumentViewerProps) => {
  const { documentId, onClose } = props;
  const { attachment, isLoading } = useFetchDocument(documentId, { isEnabled: Boolean(documentId) });

  const fileUrl = attachment?.document?.fileUrl;
  const fileType = attachment?.document?.fileType?.toLowerCase();

  if (isLoading) {
    return (
      <div style={LOADING_STYLE}>
        <Spin size="large" />
      </div>
    );
  }

  if (!fileUrl) {
    return (
      <div style={LOADING_STYLE}>
        <p>Document not found</p>
      </div>
    );
  }

  const isImage = fileType && IMAGE_FORMATS.includes(fileType);

  return (
    <div style={CONTAINER_STYLE}>
      {isImage ? (
        <div style={IMAGE_CONTAINER_STYLE}>
          <Image
            preview={false}
            width="100%"
            src={fileUrl}
            alt={attachment?.document?.label || "Document"}
            style={{ maxWidth: "100%", objectFit: "contain" }}
          />
        </div>
      ) : (
        <div style={VIEWER_CONTAINER_STYLE}>
          <embed
            src={fileUrl}
            type="application/pdf"
            width="100%"
            height="700px"
            style={{ border: "none" }}
            title="Document Viewer"
          />
        </div>
      )}
      <div style={BUTTON_CONTAINER_STYLE}>
        <Button type="primary" onClick={onClose}>
          Close
        </Button>
      </div>
    </div>
  );
};
